import React from "react";
import { Link2, UserCheck, X } from "lucide-react";

export default function TeacherAccountLinkSection({
  fetchTeamMembers,
  handleLinkAccount,
  handleUnlinkAccount,
  linkLoading,
  setShowLinkPopup,
  showLinkPopup,
  teamMembers,
  teacher,
  userProfile,
}) {
  if (userProfile?.memberRole !== "admin") {
    return null;
  }

  return (
    <div className="w-full mb-6 p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl border border-blue-100">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className={`w-8 h-8 rounded-xl flex items-center justify-center ${teacher.linkedUserId ? "bg-green-100" : "bg-gray-100"}`}>
            {teacher.linkedUserId ? (
              <UserCheck size={16} className="text-green-600" />
            ) : (
              <Link2 size={16} className="text-gray-400" />
            )}
          </div>
          <div>
            <p className="text-sm font-bold text-gray-800">앱 계정</p>
            {teacher.linkedUserId ? (
              <p className="text-xs text-green-600">{teacher.linkedUserName || "연결됨"}</p>
            ) : (
              <p className="text-xs text-gray-400">연결 안 됨</p>
            )}
          </div>
        </div>
        {teacher.linkedUserId ? (
          <button
            onClick={handleUnlinkAccount}
            className="text-xs text-red-500 hover:text-red-600 font-medium px-3 py-1.5 rounded-lg hover:bg-red-50 transition"
          >
            연결 해제
          </button>
        ) : (
          <button
            onClick={() => {
              fetchTeamMembers();
              setShowLinkPopup(true);
            }}
            className="text-xs text-blue-600 hover:text-blue-700 font-bold px-3 py-1.5 rounded-lg bg-blue-100 hover:bg-blue-200 transition"
          >
            계정 연결
          </button>
        )}
      </div>

      {showLinkPopup && (
        <div className="mt-4 p-3 bg-white rounded-xl border border-gray-200 shadow-sm">
          <div className="flex justify-between items-center mb-3">
            <p className="text-sm font-bold text-gray-800">멤버 선택</p>
            <button onClick={() => setShowLinkPopup(false)} className="text-gray-400 hover:text-gray-600">
              <X size={16} />
            </button>
          </div>
          {linkLoading ? (
            <p className="text-sm text-gray-400 text-center py-4">로딩 중...</p>
          ) : teamMembers.length === 0 ? (
            <p className="text-sm text-gray-400 text-center py-4">연결 가능한 멤버가 없습니다</p>
          ) : (
            <div className="max-h-40 overflow-y-auto space-y-1">
              {teamMembers.map((member) => (
                <button
                  key={member.uid}
                  onClick={() => handleLinkAccount(member.uid, member.name)}
                  className="w-full text-left p-2 rounded-lg hover:bg-gray-50 flex items-center gap-2 transition"
                >
                  <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-sm font-bold text-gray-600">
                    {member.name?.charAt(0) || "?"}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-800">{member.name || "이름 없음"}</p>
                    <p className="text-xs text-gray-400">{member.deptName || "부서 없음"}</p>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
